import React from 'react';
import MarketingForm from '../components/MarketingForm';

const Marketing2 = () => {
  // Annisa
  return <MarketingForm marketingNumber="Annisa" phoneNumber="81517085755" />;
};

export default Marketing2;
